import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { fetchSiteContent } from "@/lib/api";

const SiteContentContext = createContext(null);

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const data = await fetchSiteContent();
      setContent(data);
    } catch {
      setContent(null);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SiteContentContext.Provider value={{ content, setContent, refresh }}>
      {children}
    </SiteContentContext.Provider>
  );
}

export const useSiteContent = () => {
  const ctx = useContext(SiteContentContext);
  return ctx?.content;
};

export const useSiteContentCtx = () => useContext(SiteContentContext);
